import React, { useContext, useEffect, useState } from "react";
import PERFORMANCE from "../../../../Assets/Images/PERFORMANCE.png";
import STRATEGIC from "../../../../Assets/Images/STRATEGIC.png";
import VISIONARY from "../../../../Assets/Images/VISIONARY.png";
import COLLABORATIVE from "../../../../Assets/Images/COLLABORATIVE.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from "../../../../Context/GroupReportContext";
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import { logItemsOverviewData } from '../../../../utils/itemsOverviewLogger';
import { initialDataLeaderShip } from "../groupReport-pdf/QuadrantInFocus";

export const leadershipData = [
  {
    no: 21, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] is motivated by creativity.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 22, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] is motivated to push the team to win.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 23, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] is motivated to help the team connect more deeply with each other.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 24, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name] is motivated by developing a clear strategic plan.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 25, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name] believes strategic thinking is the main contributor to success.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 26, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] has found success by outworking other people.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 27, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] finds satisfaction from developing a collaborative leadership culture.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 28, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] believes success is contingent on having a clear vision.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 29, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] develops others by gaining buy-in around shared values.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 30, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] develops others by helping them see the “why” behind the work.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 31, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] develops others by coaching them toward measurable results.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 32, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name] intentionally develops others by educating them on what they need to know.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
];

const sideLabels = [
  { label: "MOTIVATIONS", bg: "#394554" },
  { label: "DRIVERS", bg: "#666666" },
  { label: "COACHING", bg: "#394554" },
];

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'PERFORMANCE':
      return <img style={{ width: "14px" }} src={PERFORMANCE} alt="PERFORMANCE" className="logo" />;
    case 'STRATEGIC':
      return <img style={{ width: "14px" }} src={STRATEGIC} alt="STRATEGIC" className="logo" />;
    case 'VISIONARY':
      return <img style={{ width: "14px" }} src={VISIONARY} alt="VISIONARY" className="logo" />;
    case 'COLLABORATIVE':
      return <img style={{ width: "14px" }} src={COLLABORATIVE} alt="COLLABORATIVE" className="logo" />;
    default:
      return null;
  }
};

const LeadershipThirdItemOverview360 = ({ apiData, reportType, pageNumber }) => {
  const [dynamicData] = useState([...initialDataLeaderShip]);
  const groupReportCtx = useContext(GroupReportContext)
  const { updateTablevaluels2Page3 } = useGroupReportDate();
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';

  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el?.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el.fullName);
  const displayData = dynamicData

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  }


  const allResults = [];
  displayData?.forEach((el, index) => {
    const res = groupReportCtx?.calculateQuestionScoreLeadership(quadrantScores?.[el.quadrant], allVariableSets, el.no, "360_overview", allAssessmentDesignation, allAssessmentHash, allAssessmentFullName);
    if (res?.averageScore !== null) {
      allResults.push(res);
    }
  })

  // Collect all scores and save to context (page3)
  useEffect(() => {
    if (allResults.length > 0) {
      const scoresArray = [];

      const thirdPageItems = dynamicData.slice(20, 32);

      thirdPageItems.forEach((item, index) => {
        const selfScore = groupReportCtx?.getAverageScore("360 Assessment", allResults, index + 20);
        const managerScore = groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index + 20);
        const directReportScore = groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index + 20);
        const peerScore = groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index + 20);
        const otherScore = groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index + 20);
        const averageScore = groupReportCtx?.getObserverAverageScore(allResults, index + 20) ?? "-";

        // Create array with scores only: [selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore]
        const itemScores = [selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore];
        scoresArray.push(itemScores);
      });

      updateTablevaluels2Page3(scoresArray);
      logItemsOverviewData({
        pageName: "Leadership Flow 3",
        items: thirdPageItems,
        allResults,
        getAverageScore: groupReportCtx.getAverageScore,
        startIndex: 20,
      });
    }
  }, [allResults, dynamicData, groupReportCtx]);

  // console.log("dynamicData", dynamicData, allResults)

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="page" style={{ paddingBottom: "0", height: "634px", boxSizing: "border-box", position: "relative" }}>
        <div className="content">
          <div className="table" style={{ position: "relative" }}>
            <div className="tableRow tableHeader" style={{ background: "#245775", color: "#fff", display: "flex", zIndex: "1", position: "relative" }}>
              <div className="cellIndex" style={{ marginLeft: "42px", display: "flex", alignItems: "center" }}>#</div>
              <div className="cellQuadrant" style={{ fontSize: "9px", width: "15%", padding: "5.5px 0px 5.5px 13px", lineHeight: "13px" }}>Quadrant</div>
              <div className="cellLogo" style={{ width: "9%" }} ></div>
              <div className="cellQuestion" style={{marginRight: "24px" }}>Question</div>
              <div className="cellscore-parent" style={{ display: "flex", marginLeft: "16px" }}>
                <div className="cellScore">S</div>
                <div className="cellScore">M</div>
                <div className="cellScore">D</div>
                <div className="cellScore">P</div>
                <div className="cellScore">O</div>
                <div className="cellScore">A</div>
              </div>
            </div>
            {dynamicData.slice(0, 12).map((item, index) => {
              const selfScore = Number(groupReportCtx?.getAverageScore("360 Assessment", allResults, index + 20));
              const managerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index + 20));
              const directReportScore = Number(groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index + 20));
              const peerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index + 20));
              const otherScore = Number(groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index + 20));
              const averageScore = Number(groupReportCtx?.getObserverAverageScore(allResults, index + 20));
              const getLabelByIndex = (idx) => {
                if (idx === 0) {
                  return sideLabels[0].label;
                }
                return sideLabels[Math.floor(idx / 4)]?.label;
              };
              const getStyleByIndex = (idx) => {
                if (idx === 0) {
                  return { top: "18px", height: "33%", backgroundColor: sideLabels[0].bg };
                }
                if (idx === 4) {
                  return { top: "35.9%", height: "33%", backgroundColor: sideLabels[Math.floor(idx / 4)]?.bg };
                }
                return { top: "68%", height: "35%", backgroundColor: sideLabels[Math.floor(idx / 4)]?.bg };
              };

              return <div key={index} style={{ display: "flex", alignItems: "center", padding: "5px 0", }} className={`tableRow ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`}>
                <div className='cellIndex'></div>
                {index === 0 || index % 4 === 0 ? (
                  <div className="sidelables" style={getStyleByIndex(index)}>
                    {getLabelByIndex(index)}
                  </div>
                ) : null}
                <div className="cellIndex" style={{ marginLeft: "30px" }}>{index + 21}.</div>
                <div className="cellQuadrant" style={{ width: "75px", marginLeft: "11px" }}>{leadershipData[index].quadrant}</div>
                <div className="cellLogo">{Logo(leadershipData[index].quadrant)}</div>
                <div className="cellQuestion">{leadershipData[index].question.replace(/\[First Name\]/g, respondentName)}</div>
                <div className="cellScore-parent" style={{ display: "flex", alignItems: "center", marginLeft: "" }}>
                  <div className="cellScore">{Number.isNaN(selfScore) ? "-" : selfScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(managerScore) ? "-" : managerScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(directReportScore) ? "-" : directReportScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(peerScore) ? "-" : peerScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(otherScore) ? "-" : otherScore.toFixed(1)}</div>
                  <div className="cellScore">{averageScore === 0 || Number.isNaN(averageScore) ? "-" : averageScore.toFixed(1)}</div>
                </div>
              </div>
            })}
          </div>
        </div>
        <div className='details-footer' style={{ background: "#EAF1F5", fontSize: "10px", margin: "0", padding: "4px 10px", marginTop: "auto", marginBottom: "4px" }}>
          <ul className='details-list'>
            <li>S - Self</li>
            <li>M - Manager</li>
            <li>D - Direct Report</li>
            <li>P - Peer</li>
            <li>O - Other</li>
            <li>A - Average</li>
          </ul>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default LeadershipThirdItemOverview360;
